export default __webpack_public_path__ + "static/thumbnail-video-generic-681fd2b4d33c73df7452bfb0e0e2b2c9.jpeg";